import React from 'react'
import {findDOMNode} from "react-dom"
import PopoverComponent, {
    PopoverComponentProps,
    PopoverComponentState
} from "../../../../core/gd-components/base-component/popover-component"

import Popover from "../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../gd-components/gd-popover/popover-position"
import PopoverAddColumn from './popover/popover'
import {PopoverAttachmentType} from "../../../gd-components/gd-popover/@const";
import {FieldSelectorConfig} from "./convert-fields-structure";

export type AddColumnProps = {
    className?              : string

    manageColumnsConfig     : any[]

    fields                  : any[]     // all available fields
    columns?                : any[]     // already added fields
    mandatoryColumnsIds?    : ID[]

    attachment?             : string
    targetAttachment?       : string
    attachmentType?         : PopoverAttachmentType
    offset?                 : string

    onToggleColumn          : func


    onNewColumn?            : func
    showAdd                 : boolean   // if false no add field will be shown

    btnClass?               : string    // class we use for add btn itself
} & PopoverComponentProps

let showPopover = false

export default class AddColumn<T extends AddColumnProps> extends PopoverComponent<T, PopoverComponentState> {

    static defaultProps = {
        btnClass            : 'gd-add-column-new',

        showAdd             : true,

        mandatoryColumnsIds : [],

        attachment          : "top right",
        targetAttachment    : "bottom right",
        attachmentType      : "horizontal",
        offset              : "0 -16"
    }

    constructor(props: T) {
        super(props)

        this.state = _.assign(this.state, {
            showPopover: showPopover
        })
    }

    componentDidMount() {
        showPopover = false
    }

    hidePopover(e?: React.MouseEvent, callback?: func) {
        super.hidePopover(e, callback)
        showPopover = false
    }

    onAddCustomField = () => {
        this.hidePopover()
    }

    onToggleColumn = (id: ID | null) => {
        showPopover = true
        this.props.onToggleColumn && this.props.onToggleColumn(id)
    }

    onNewCustomField = () => {
        this.hidePopover()

        gd.modals.customField.createNewField([],(field)=>{
            this.props.onNewColumn && this.props.onNewColumn(field)
            gd.modal.hide()
        })
    }

    renderPopover() {

        const config: FieldSelectorConfig = {groupedFields: this.props.manageColumnsConfig, allFields: this.props.fields}

        const popoverPosition = new PopoverPosition({
            attachment      : this.props.attachment,
            targetAttachment: this.props.targetAttachment,
            attachmentType  : this.props.attachmentType as PopoverAttachmentType,
            offset          : this.props.offset,
        })

        return (
            <Popover popoverClass       = "gd-popover-add-column-new"
                     position           = {popoverPosition}
                     onClickOutside     = {()=>{this.hidePopover()}}
                     getTargetFunc      = {()=>findDOMNode(this)}>
                <PopoverAddColumn config                = {config}
                                  fields                = {this.props.fields}
                                  columns               = {this.props.columns}
                                  selectedFieldIds      = {[]}
                                  mandatoryColumnsIds   = {this.props.mandatoryColumnsIds}
                                  isAddVisible          = {this.props.showAdd}
                                  hidePopover           = {this.hidePopover}
                                  onToggleColumn        = {this.onToggleColumn}
                                  onNewCustomField      = {this.onNewCustomField}/>
            </Popover>
        )
    }

    render() {
        const classes = Classes(this.props.btnClass, this.props.className, {
            'show-popover': this.state.showPopover
        })

        return (
            <div className={classes} onClick={this.showPopover}>
                {this.state.showPopover && this.renderPopover()}
            </div>
        )
    }
}
